export const PLAN_ORDER = ["free", "fun", "pro", "agent"];
export const CHECKOUT_ENABLED_PLANS = ["fun", "pro"];
export const PLAN_METADATA = Object.freeze({
  free: {
    label: "Free",
    monthlyPriceDisplay: "$0/month",
  },
  fun: {
    label: "Fun",
    monthlyPriceDisplay: "$1/month",
  },
  pro: {
    label: "Pro",
    monthlyPriceDisplay: "$10/month",
  },
  agent: {
    label: "Agent",
    monthlyPriceDisplay: "$100/month",
  },
});

export function normalizePlan(value, fallback = "free") {
  const normalized = String(value || "").trim().toLowerCase();
  return PLAN_ORDER.includes(normalized) ? normalized : fallback;
}

function planMetadata(plan) {
  return PLAN_METADATA[normalizePlan(plan)] || PLAN_METADATA.free;
}

export function getPlanLabel(plan) {
  return planMetadata(plan).label;
}

export function getPlanMonthlyPriceDisplay(plan) {
  return String(planMetadata(plan).monthlyPriceDisplay || "").trim();
}

export function formatPlanRequirementCopy(plan, { monthlyPrice } = {}) {
  const label = getPlanLabel(plan);
  const resolvedMonthlyPrice = typeof monthlyPrice === "string"
    ? monthlyPrice.trim()
    : getPlanMonthlyPriceDisplay(plan);

  if (!resolvedMonthlyPrice) {
    return `${label} plan or higher`;
  }

  return `${label} plan or higher (${resolvedMonthlyPrice})`;
}

export function planIndex(plan) {
  return PLAN_ORDER.indexOf(normalizePlan(plan));
}

export function maxPlan(left, right) {
  return planIndex(left) >= planIndex(right) ? normalizePlan(left) : normalizePlan(right);
}

export function canAccessPlan(targetPlan, effectivePlan) {
  return planIndex(targetPlan) <= planIndex(effectivePlan);
}

export function isCheckoutEnabledPlan(plan) {
  return CHECKOUT_ENABLED_PLANS.includes(normalizePlan(plan, ""));
}

export function firstCheckoutEnabledPlan(fallback = "fun") {
  return CHECKOUT_ENABLED_PLANS[0] || fallback;
}

export function normalizeCheckoutPlan(plan, fallback = "fun") {
  const normalizedFallback = isCheckoutEnabledPlan(fallback)
    ? normalizePlan(fallback)
    : firstCheckoutEnabledPlan();
  return isCheckoutEnabledPlan(plan) ? normalizePlan(plan) : normalizedFallback;
}
